<template>    
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-9">                  
                <div class="row mb-5">                    
                    <div class="col-lg-12 mt-lg-0 mt-4">
                        <breed-detail />                        
                    </div>
                </div>
            </div>
        </div>
        <div class="row"></div>
    </div>        
</template>

<script>
import BreedDetail from "./components/BreedDetail.vue"

export default {
    name: 'Breed_edit_page',
    components: {        
        BreedDetail
    },
    data() {
        return {
            Id: '',
            breed: [],
            gets: []
        }
    },
    async mounted() {
        this.id = this.$route.params.id;   
        console.log('Route ID:', this.id);   
    },
}
</script>